// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__PFPuE","importantInfo":"styles_importantInfo__owA9O"};